module.exports = __webpack_public_path__ + "img/720.76fc9c01.svg";